import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Spinner } from "@nextui-org/react";
import Cookies from "js-cookie";
import { toast } from "react-hot-toast";
import { COMPANY_INDEX_PATH, LOGIN_PATH } from "../../services/routes";
import { BASE_URL } from "../../services/api";
import axios from "axios";

export default function SimpelLoginPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleSimpelLogin = async () => {
      try {
        // Ambil token dari URL parameter
        const token = searchParams.get("_token");

        if (!token) {
          throw new Error("Token SIMPEL tidak ditemukan");
        }

        // Hit endpoint SIMPEL login di backend
        const response = await axios.post(
          `${BASE_URL}/api/auth/simpel/login`,
          {},
          {
            headers: {
              Authorization: token,
            },
          }
        );

        if (!response.data?.accessToken) {
          throw new Error("Login gagal. Token tidak valid.");
        }

        // Set cookies untuk token
        Cookies.set("accessToken", response.data.accessToken, {
          expires: 0.5,
          secure: true,
          sameSite: "strict",
        });
        Cookies.set("refreshToken", response.data.refreshToken, {
          expires: 0.5,
          secure: true,
          sameSite: "strict",
        });
        Cookies.set("sessionExpired", response.data.sessionExpired, {
          expires: 0.5,
          secure: true,
          sameSite: "strict",
        });
        // Simpan token SIMPEL untuk digunakan saat fetch data perusahaan
        Cookies.set("simpelToken", token, {
          expires: 7, // 7 days
          secure: true,
          sameSite: "strict",
        });

        toast.success("Login berhasil dengan SIMPEL!");

        // Redirect ke halaman perusahaan
        navigate(COMPANY_INDEX_PATH, { replace: true });
      } catch (error) {
        console.error("Error during SIMPEL login:", error);
        const errorMessage = error.response?.data?.message || error.message || "Gagal login dengan SIMPEL. Silakan coba lagi.";
        setError(errorMessage);
        toast.error(errorMessage);

        // Redirect ke login page setelah 3 detik
        setTimeout(() => {
          navigate(LOGIN_PATH, { replace: true });
        }, 3000);
      }
    };

    handleSimpelLogin();
  }, [searchParams, navigate]);

  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-white">
      <div className="flex flex-col items-center gap-6">
        {error ? (
          <>
            <div className="text-danger text-xl font-semibold text-center px-4">{error}</div>
            <p className="text-ink-500 text-center">Mengalihkan ke halaman login...</p>
          </>
        ) : (
          <>
            <Spinner size="lg" color="primary" />
            <div className="text-xl font-semibold text-center">Memproses Login SIMPEL...</div>
            <p className="text-ink-500 text-center">Mohon tunggu sebentar</p>
          </>
        )}
      </div>
    </div>
  );
}
